import { render, staticRenderFns } from "./ProfileAboutBlocks.vue?vue&type=template&id=355ad71f&scoped=true&"
import script from "./ProfileAboutBlocks.vue?vue&type=script&lang=js&"
export * from "./ProfileAboutBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ad71f",
  null
  
)

export default component.exports